import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import ProductDescriptionItemsBlockData from 'app/Models/Content/ProductDescriptionItemsBlockData';
import React from 'react';

const ProductDescriptionItemsBlock = ({data, context}: ComponentProps<ProductDescriptionItemsBlockData>) => {
  const {fadeClass, ref} = useFadeIn();

  return (
    <div ref={ref} className={`ProductDescriptionItemsBlock ${fadeClass} is${data.items.expandedValue.length}__items`}>
      <ContentArea noWrap context={context} data={data.items} />
    </div>
  );
};

export default ProductDescriptionItemsBlock;
